import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import 'jquery-ui/ui/widgets/autocomplete.js';
import Inputmask from 'inputmask/dist/inputmask.min';
import { Bonus } from '../bonus/bonus.js';
import { Popup } from '../popup/popup.js';
import { Tooltip } from '../tooltip/tooltip';

const DaDataUrl =
	'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';
const DaDataToken = 'f9145577bad35c7606cbdd84d012ff8ae653bc77';
//const DaDataToken = '9577ba68a0e38c8b8b2b23f2fe713ee12be58be8';

class Input {
	constructor() {
		this.cityinput = $('[data-find-city]');

		this.initialize();
	}

	initialize() {
		console.log('Input initialize');

		let search = $('[data-search]');
		let searchResults = $('#search-results');
		let suggestions = search.closest('form').find('[data-suggestions]');
		let body = $('body');
		let reset = $('[data-suggestions-reset]');
		let cityinput = this.cityinput;
		let arReturn = '';

		let cartPersonalAddressMainTemplate = `
            <div class="card-login__left-adress" data-address-main>
                <svg class="icon check2" aria-hidden="true">
                    <use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#check2"></use>
                </svg>
                <span>основной адрес</span>
            </div>`;

		search.off('keyup').on('keyup', function() {
			let el = $(this);
			if (el.val().length > 3) {
				let query = el.val();

				let _ajax = search.data('ajax');
				if (_ajax) _ajax.abort();

				_ajax = $.ajax({
					url: '/local/ajax/search_top.php',
					method: 'post',
					dataType: 'html',
					data: { q: query, fast_search: 'y' }
				})
					.done(function(response) {
						searchResults.html(response);
						updateLazy();
					})
					.fail(function(response) {
						console.log(response);
					});

				search.data('ajax', _ajax);

				suggestions.show();
				reset.show();
			} else {
				suggestions.hide();
				reset.hide();
			}

			loadSuggestions(el, suggestions, body);
		});

		function updateLazy() {
			let img = searchResults.find('.lazyload');
			let lazy = new LazyLoad(img);
			lazy.loadImages();
		}

		reset.off('click').on('click', function() {
			suggestions.hide();
			reset.hide();
			suggestions.children().removeAttr('style');
			body.removeClass('overflow-y');

			search.val('');
		});

		function loadSuggestions(el, suggestions, body) {
			let ww = $(window).width();
			let notify = $('[data-notify]');

			if (notify.length > 0) {
				notify = notify.innerHeight();
			} else {
				notify = 0;
			}

			let top =
				$('[data-header-top]').innerHeight() +
				$('[data-search-form]').innerHeight() +
				notify +
				31;
			let height = $(window).height() - top;

			if (ww < 544) {
				suggestions.children().css({ top: top + 'px' });
				suggestions.children().height(height);
				body.addClass('overflow-y');
			} else {
				suggestions.children().removeAttr('style');
				body.removeClass('overflow-y');
			}
		}

		$(window)
			.off('resize')
			.on('resize', function() {
				// loadSuggestions(search, suggestions, body);
				suggestions.children().removeAttr('style');
				body.removeClass('overflow-y');
			});

		// Валидация
		$.validator.addMethod(
			'phone',
			function(value, element) {
				return (
					this.optional(element) ||
					/\s\((?!89)\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(value)
				);
			},
			'Пожалуйста, укажите номер телефона'
		);

		$.validator.methods.email = function(value, element) {
			return (
				this.optional(element) ||
				/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(
					value
				)
			);
		};

		$.validator.addMethod('regex', function(value, element, regexpr) {
			return regexpr.test(value);
		});

		$.validator.addMethod(
			'pass',
			function(value) {
				return (
					/^([A-Za-z0-9\d=!\-@._*])*$/.test(value) && // consists of only these
					// && /[A-z]/.test(value) // has a lowercase letter
					// && /[A-Z]/.test(value)
					/\d/.test(value) &&
					/.{8,}/.test(value)
				);
			},
			'Пароль должен содержать не менее 8 символов и включать 1 цифру'
		);

		$.validator.addMethod(
			'notEqual',
			function(value, element, param) {
				return this.optional(element) || value !== $(param).val();
			},
			'Значение не должно совпадать'
		);

		$.validator.addMethod('complete', function(value, element) {
			return $(element).hasClass('complete');
		});

		$.validator.addMethod('found', function(value, element) {
			return $(element).hasClass('found');
		});

		$('[data-validate]').each(function() {
			let validate = $(this);
			if (validate.data('init') === 'Y') {
				return true;
			}
			validate.data('init', 'Y');

			var formValidate = validate.validate({
				errorClass: 'invalid',
				errorElement: 'label',
				focusInvalid: false,
				invalidHandler: function(form, validator) {
					if (!validator.numberOfInvalids()) return;

					$('html, body').animate(
						{
							scrollTop: $(validator.errorList[0].element).offset().top - 40
						},
						2000
					);
				},
				highlight: function(element) {
					let el = $(element);

					el.closest('[data-input-wrap]')
						.find('[data-input-label]')
						.addClass('label-invalid');
					el.addClass('invalid');
				},
				unhighlight: function(element) {
					let el = $(element);

					el.closest('[data-input-wrap]')
						.find('[data-input-label]')
						.removeClass('label-invalid');
					el.removeClass('invalid');
				},
				submitHandler: function(form) {
					let _formName = $(form).attr('name');

					if (_formName === 'ORDER_FORM') {
						if (
							!$(form)
								.find('[data-property-location]')
								.val()
						) {
							$(form)
								.find('[data-error-city-select]')
								.removeClass('hidden')
								.addClass('invalid');
							$('html, body')
								.stop()
								.animate(
									{
										scrollTop: $('[data-error-city-select]').offset().top - 40
									},
									100
								);

							return false;
						}

						if (
							$('[data-delivery-type="courier"]').hasClass('active') &&
							$('[data-address-list]').length > 0 &&
							!$('[data-address-list]').find('.active').length
						) {
							$('.error-address').show();
							$('html, body').scrollTop($('.error-address').offset().top - 60);

							return false;
						}

						if (
							$('[data-delivery-type="pvz"]').hasClass('active') &&
							!$('[data-delivery-total]').hasClass('active')
						) {
							$('.error-pvz').show();
							$('html, body').scrollTop($('.error-pvz').offset().top - 60);

							return false;
						}

						if (
							$('[data-delivery-type="shop"]').hasClass('active') &&
							!$('[data-delivery-total-shop]').hasClass('active')
						) {
							$('.error-shop').show();
							$('html, body').scrollTop($('.error-shop').offset().top - 60);

							return false;
						}

						if ($(form).find('.active[data-delivery-type="courier"]').length) {
							$(form)
								.find('[data-property-store-id]')
								.val('');
							$('[data-input-address]')
								.first()
								.trigger('blur');
						}

						if (!$(form).find('input[name="soa-action"]').length) {
							$(form).append(
								'<input type="hidden" name="soa-action" value="saveOrderAjax">'
							);
						}

						if ($(form).find('.invalid:visible').length) {
							return false;
						}

						localStorage.removeItem('cookieAdress');
						localStorage.removeItem('cookiePvz');
						localStorage.removeItem('cookieDateStart');
					}

					if (_formName === 'personal-address-add') {
						if (
							!$(form)
								.find('[data-location-id]')
								.val()
						) {
							formValidate.showErrors({ city: 'Пожалуйста, выберите город' });
							return;
						}
					}

					$('body').addClass('body--loading'); // preloader

					if ($(form).data('ajax') === '') {
						let _action = $(form).attr('action');
						let _alerts = $(form).find('[data-alerts]');

						if (_formName === 'regform') {
							$(form)
								.find('[name="REGISTER[LOGIN]"]')
								.val(
									$(form)
										.find('[name="REGISTER[EMAIL]"]')
										.val()
								);

							let day = $(form)
								.find('[name="birthDay"] option:selected')
								.val()
								.trim();
							let month = $(form)
								.find('[name="birthMonth"] option:selected')
								.val()
								.trim();
							let year = $(form)
								.find('[name="birthYear"] option:selected')
								.val()
								.trim();
							if (day && month && year) {
								$(form)
									.find('[name="REGISTER[PERSONAL_BIRTHDAY]"]')
									.val(day + '.' + month + '.' + year);
							}

							if (
								$(form)
									.find('input[name="check"]')
									.val() !== 'Y'
							) {
								$.post(
									'/local/ajax/authcard.php',
									{
										sessid: BX.bitrix_sessid(),
										action: 'sendcode',
										name: $(form)
											.find('[name="REGISTER[NAME]"]')
											.val(),
										last_name: $(form)
											.find('[name="REGISTER[LAST_NAME]"]')
											.val(),
										second_name: $(form)
											.find('[name="REGISTER[SECOND_NAME]"]')
											.val(),
										phone: $(form)
											.find('[name="REGISTER[PERSONAL_PHONE]"]')
											.val(),
										email: $(form)
											.find('[name="REGISTER[EMAIL]"]')
											.val()
									},
									function(e) {
										$('body').removeClass('body--loading'); // preloader

										if (e['RESULT'] === 'ERROR') {
											let validateErrors = {};
											validateErrors['REGISTER[' + e['FIELD'] + ']'] =
												'Зарегистрирована попытка нечестной регистрации';
											formValidate.showErrors(validateErrors);
										} else {
											$('#registerCard')
												.find('.check-phone')
												.html(
													$(form)
														.find('[name="REGISTER[PERSONAL_PHONE]"]')
														.val()
												);
											$('#registerCard')
												.find('.check-email')
												.html(
													$(form)
														.find('[name="REGISTER[EMAIL]"]')
														.val()
												);

											let _popup = new Popup($('#registerCard'));
											_popup.open();
										}
									},
									'json'
								);

								return false;
							}
						}

						let _data = $(form).serializeArray();

						// меняем формат всех полей type="date"
						$.each(_data, function(key, value) {
							if (
								$(form)
									.find('[name="' + value['name'] + '"]')
									.attr('type') === 'date'
							) {
								var birthdayVal = value['value'];
								if (birthdayVal.length) {
									var birthDay = value['value'].split('-');
									_data[key]['value'] =
										birthDay[2] + '.' + birthDay[1] + '.' + birthDay[0];
								}
							}
						});

						if (_formName === 'profile') {
							$(form)
								.find('.alert')
								.hide();
						}

						$.ajax({
							type: 'POST',
							url: _action,
							data: _data,
							dataType: 'json',
							success: function(response) {
								let validateErrors = {};
								let errors = [];

								if ($(form).data('bonus') === '') {
									let _bonusForm = new Bonus($(form), formValidate);
									_bonusForm.result(response);
								}

								if (_formName === 'regform') {
									let _toPersonal = false;

									if (response['success'] === 'Y') {
										_alerts
											.show()
											.find('.alert')
											.addClass('alert-success')
											.html(response['success']);

										_toPersonal = true;
									} else {
										$.each(response['errors'], function(key, value) {
											if (
												$(form).find('[name="REGISTER[' + key + ']"]').length
											) {
												validateErrors['REGISTER[' + key + ']'] = value.replace(
													'#FIELD_NAME#',
													''
												);
											} else if (value === 'Неверно введено слово с картинки') {
												validateErrors['captcha_word'] = value;
											} else if (
												value.indexOf('Пользователь с таким email') !== -1
											) {
												validateErrors['REGISTER[EMAIL]'] =
													'Пользователь с таким email уже существует';
											} else if (value.indexOf('Пароль должен быть') !== -1) {
												validateErrors['REGISTER[PASSWORD]'] = value;
											} else {
												errors.push(value);
											}
										});
										if (!$.isEmptyObject(validateErrors)) {
											formValidate.showErrors(validateErrors);
										}

										if (errors.length) {
											_alerts
												.show()
												.find('.alert')
												.html(errors.join('<br>'));
										} else {
											_alerts.hide();

											if ($.isEmptyObject(validateErrors)) {
												_toPersonal = true;
											}
										}
									}

									if ($(form).find('[name="captcha_sid"]').length) {
										$(form)
											.find('[name="captcha_sid"]')
											.val(response['result']['captcha']);
										$(form)
											.find('[data-captcha]')
											.attr(
												'src',
												'/bitrix/tools/captcha.php?captcha_sid=' +
													response['result']['captcha']
											);
									}

									if (_toPersonal) {
										let birthdaySend = $(form)
											.find('[name="REGISTER[PERSONAL_BIRTHDAY]"]')
											.val();
										let emailSend = $(form)
											.find('[name="REGISTER[EMAIL]"]')
											.val();
										let genderVal = $(form)
											.find('[name="REGISTER[PERSONAL_GENDER]"]')
											.val();
										let genderSend = '';
										if (genderVal == 'M') {
											genderSend = 'Male';
										}
										if (genderVal == 'F') {
											genderSend = 'Female';
										}
										let day = parseInt(
											$(form)
												.find('[name="birthDay"] option:selected')
												.val()
												.trim()
										);
										let month = parseInt(
											$(form)
												.find('[name="birthMonth"] option:selected')
												.val()
												.trim()
										);
										let year = parseInt(
											$(form)
												.find('[name="birthYear"] option:selected')
												.val()
												.trim()
										);
										let now = new Date(); //Текущя дата
										let today = new Date(
											now.getFullYear(),
											now.getMonth(),
											now.getDate()
										); //Текущя дата без времени
										let dob = new Date(year, month, day); //Дата рождения
										let dobnow = new Date(
											today.getFullYear(),
											dob.getMonth(),
											dob.getDate()
										); //ДР в текущем году
										let age; //Возраст
										// Возраст = текущий год - год рождения
										age = today.getFullYear() - dob.getFullYear();
										//Если ДР в этом году ещё предстоит, то вычитаем из age один год
										if (today < dobnow) {
											age = age - 1;
										}
										(window['rrApiOnReady'] =
											window['rrApiOnReady'] || []).push(function() {
											rrApi.setEmail(emailSend, {
												gender: genderSend,
												age: 21,
												birthday: birthdaySend
											});
										});

										window.dataLayer = window.dataLayer || [];
										dataLayer.push({
											event: 'sign_up',
											method: 'From site'
										});
										try {
											ym(79276948, 'reachGoal', 'sign_up');
										} catch (e) {}
										window.location.href = '/personal/';
									}
								}

								if (_formName === 'profile') {
									if (response['success'] === 'Y') {
										_alerts.addClass('alert-success').show();

										let formSubscribe = $('form[name="profile-subscribe"]');
										if (formSubscribe.length && response['subscribe']) {
											formSubscribe
												.find('input[name="email"]')
												.val(response['subscribe']['email']);

											let subscribeTextNode = formSubscribe.find(
												'.card-login__body p'
											);
											let subscribeSubmitNode = formSubscribe.find(
												'[type="submit"]'
											);

											if (response['subscribe']['status'] === 'YES') {
												subscribeTextNode.text(
													subscribeTextNode.data('subscribe')
												);
												subscribeSubmitNode.val(
													subscribeSubmitNode.data('subscribe')
												);
											} else {
												subscribeTextNode.text(
													subscribeTextNode.data('unsubscribe')
												);
												subscribeSubmitNode.val(
													subscribeSubmitNode.data('unsubscribe')
												);
											}
										}
									} else {
										$.each(response['errors'], function(key, value) {
											if (value.indexOf('Неверная дата рождения') !== -1) {
												validateErrors['PERSONAL_BIRTHDAY'] = value;
											} else if (value) {
												errors.push(value);
											}
										});

										if (!$.isEmptyObject(validateErrors)) {
											formValidate.showErrors(validateErrors);
										}

										if (errors.length) {
											_alerts
												.show()
												.removeClass('alert-success')
												.addClass('alert-danger')
												.html(errors.join('<br>'));
										} else {
											_alerts.hide();
										}
									}
								}

								if (_formName === 'profilepass') {
									if (response['success'] === 'Y') {
										_alerts.addClass('alert-success').show();
									} else {
										_alerts.hide();

										$.each(response['errors'], function(key, value) {
											if (
												value.indexOf('Старый пароль указан неверно') !== -1
											) {
												validateErrors['OLD_PASSWORD'] = value;
											} else if (value.indexOf('Пароль должен') !== -1) {
												validateErrors['NEW_PASSWORD'] = value;
											} else if (value) {
												errors.push(value);
											}
										});

										if (!$.isEmptyObject(validateErrors)) {
											formValidate.showErrors(validateErrors);
										}

										if (errors.length) {
											_alerts
												.show()
												.removeClass('alert-success')
												.addClass('alert-danger')
												.html(errors.join('<br>'));
										} else {
											_alerts.removeClass('alert-danger').hide();
										}
									}
								}

								if (_formName === 'profile-subscribe') {
									let subscribeTextNode = $(form).find('.card-login__body p');
									let subscribeSubmitNode = $(form).find('[type="submit"]');

									if (
										response['RESULT'] === 'Y' ||
										response['RESULT'] === 'A'
									) {
										$(form)
											.find('input[name="action"]')
											.val('unsubscribe');
										subscribeTextNode.text(subscribeTextNode.data('subscribe'));
										subscribeSubmitNode.val(
											subscribeSubmitNode.data('subscribe')
										);
									} else {
										$(form)
											.find('input[name="action"]')
											.val('subscribe');
										subscribeTextNode.text(
											subscribeTextNode.data('unsubscribe')
										);
										subscribeSubmitNode.val(
											subscribeSubmitNode.data('unsubscribe')
										);
									}
								}

								if (_formName === 'ORDER_FORM') {
									localStorage.removeItem('cookieAdress');
									localStorage.removeItem('cookiePvz');
									localStorage.removeItem('cookieDateStart');

									if (response.order.ERROR) {
										if (typeof window.error === 'undefined') {
											window.error = 'Y';
											$('#btn-popup-cart-error').trigger('click');
										} else {
											window.location.href = '/personal/cart/';
										}
									} else if (
										response &&
										response['order'] &&
										response['order']['REDIRECT_URL']
									) {
										window.location.href = response['order']['REDIRECT_URL'];
									}
								}

								if (_formName === 'personal-address-add') {
									if (
										response.status === 'ok' &&
										!$(form).find('[data-address-id="' + response.id + '"]')
											.length
									) {
										let list = $('[data-address-list]');

										let locationId = $(form)
											.find('[data-location-id]')
											.val();
										let city = $(form)
											.find('[data-find-city]')
											.val();
										let street = $(form)
											.find('[data-adress-street]')
											.val();
										let house = $(form)
											.find('[data-adress-house]')
											.val();
										let flat = $(form)
											.find('[data-adress-flat]')
											.val();

										let isCart = $('[data-cart]').length > 0;
										let template = '';

										if (isCart) {
											let main = '';
											if (response.is_main) {
												list.find('[data-address-main]').remove();

												main = cartPersonalAddressMainTemplate;
											}

											template = `
                                            <div class="card-login__item" data-adress-wrap data-address-id="${response.id}">
                                                <div class="card-login card-login--no-border">
                                                    <div class="card-login__body card-login__body--column">
                                                        <div class="card-login__left">
                                                            <div class="card-login__left-row">
                                                                <h5 class="mb-0" data-adress-city data-location-id="${locationId}">${city}</h5>
                                                                ${main}
                                                            </div>
                                                            <p data-adress-text>
                                                                <span data-address-street>${street}</span>,
                                                                д. <span data-address-building>${house}</span>,
                                                                кв./оф. <span data-address-flat>${flat}</span>
                                                            </p>
                                                        </div>
                                                        <div class="card-login__right d-flex">
                                                            <div class="d-flex flex-wrap align-items-center">
                                                                <a class="card-login__icon" href="#edit-adress" data-popup title="Изменить">
                                                                    <svg class="icon edit" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#edit"></use></svg>
                                                                </a>
                                                                <a class="card-login__icon" href="#delete-adress" data-popup title="Удалить">
                                                                    <svg class="icon delete" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#delete"></use></svg>
                                                                </a>
                                                                <a class="btn btn--md btn--not-transform pl-3 pr-3 card-login__btn btn--border" href="#" title="Выбран" data-adress-change>
                                                                    <svg class="icon check3" aria-hidden="true">
                                                                        <use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#check3"></use>
                                                                    </svg>
                                                                    <span>Доставить сюда</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>`;
										} else {
											template = `
                                            <div class="col-12 col-md-6 mb-5" data-adress-wrap data-address-id="${response.id}">
                                                <div class="card-login">
                                                    <div class="card-login__body">
                                                        <h5 data-adress-city data-location-id="${locationId}">${city}</h5>
                                                        <p data-adress-text>
                                                            <span data-address-street>${street}</span>,
                                                            д. <span data-address-building>${house}</span>,
                                                            кв./оф. <span data-address-flat>${flat}</span>
                                                        </p>
                                                        <div class="d-flex flex-wrap align-items-center">
                                                            <a class="btn btn--md btn--border btn--not-transform pl-3 pr-3 mr-4" href="#edit-adress" data-popup title="Изменить">
                                                                <svg class="icon edit" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#edit"></use></svg>
                                                                <span>Изменить</span>
                                                            </a>
                                                            <a class="btn btn--md btn--border btn--not-transform pl-3 pr-3 mr-xs-4" href="#delete-adress" data-popup title="Удалить">
                                                                <svg class="icon delete" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#delete"></use></svg>
                                                                <span>Удалить</span>
                                                            </a>
                                                            <a class="link card-login__adress-base mt-3 mt-xs-0" href="#" title="Сделать основным" data-adress-active>Сделать основным</a>
                                                            <div class="card-login__adress mt-3 mt-xs-0">
                                                                <svg class="icon check2" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#check2"></use></svg>
                                                                <span>основной адрес</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>`;
										}

										list.append(template);

										list
											.find('[data-address-id="' + response.id + '"]')
											.find('[data-popup]')
											.each(function() {
												let _popup = new Popup($(this));
												_popup.initPopup();
											});

										if (
											isCart &&
											list.find('[data-adress-wrap]').length === 1 &&
											window.Cart
										) {
											$('.error-address').hide();
											window.Cart.setPersonalAddressActive(response.id);
											window.Cart.checkSelectedCityAndPersonalAddress();
										}
									}

									$.magnificPopup.close();
								}

								if (_formName === 'personal-address-edit') {
									if (response.status === 'ok') {
										let list = $('[data-address-list]');
										let wrap = list.find(
											'[data-address-id="' + response.id + '"]'
										);

										wrap
											.find('[data-adress-city]')
											.data('location-id', response.params.UF_LOCATION);
										wrap.find('[data-adress-city]').text(response.city);
										wrap
											.find('[data-address-street]')
											.text(response.params.UF_STREET);
										wrap
											.find('[data-address-building]')
											.text(response.params.UF_BUILDING);
										wrap
											.find('[data-address-flat]')
											.text(response.params.UF_FLAT);

										let isCart = $('[data-cart]').length > 0;

										if (isCart) {
											let isMain = wrap.find('[data-address-main]').length > 0;

											if (!isMain && response.is_main) {
												list.find('[data-address-main]').remove();
												wrap
													.find('[data-adress-city]')
													.after(cartPersonalAddressMainTemplate);
											}

											if (isMain && !response.is_main) {
												let firstAddress = $('[data-address-list]')
													.find('[data-adress-wrap]')
													.first();

												list.find('[data-address-main]').remove();
												firstAddress
													.find('[data-adress-city]')
													.after(cartPersonalAddressMainTemplate);
											}

											if (wrap.children().hasClass('active') && window.Cart) {
												window.Cart.setPersonalAddressActive(
													wrap.data('address-id')
												);
												window.Cart.checkSelectedCityAndPersonalAddress();
											}
										}
									}

									$.magnificPopup.close();
								}

								if (_formName === 'personal-address-delete') {
									if (response.status === 'ok') {
										let wrap = $('[data-address-list]').find(
											'[data-address-id="' + response.id + '"]'
										);
										let isCart = $('[data-cart]').length > 0;
										let isActive = wrap.children().hasClass('active');
										let isMain = wrap.find('[data-address-main]').length > 0;

										wrap
											.removeAttr('data-address-id')
											.removeAttr('data-adress-wrap');
										wrap.addClass('hidden');

										if (isCart && window.Cart) {
											let firstAddress = $('[data-address-list]')
												.find('[data-adress-wrap]')
												.first();

											if (firstAddress.length) {
												if (isMain) {
													firstAddress
														.find('[data-adress-city]')
														.after(cartPersonalAddressMainTemplate);
												}

												if (isActive) {
													window.Cart.setPersonalAddressActive(
														firstAddress.data('address-id')
													);
													window.Cart.checkSelectedCityAndPersonalAddress();
												}
											} else {
												$('input[name="ORDER_PROP_street"]').val('');
												$('input[name="ORDER_PROP_house"]').val('');
												$('input[name="ORDER_PROP_apartment"]').val('');
												$('[data-property-address]').val('');
												$('input[name="personal_address_id"]').val('');
												$('input[name="personal_address_city_id"]').val('');

												let citySelector = $('[data-location-city]');
												citySelector.off('click');
												let _popup = new Popup(citySelector);
												_popup.initPopup();
											}
										}
									}

									$.magnificPopup.close();
								}

								if (
									_formName === 'auth-forgot-password' ||
									_formName === 'auth-change-password'
								) {
									$('[data-alert-error]').addClass('hidden');

									if (response.status === 'ok') {
										$('[data-form]').hide();
										$('[data-alert-success]')
											.html(response.message)
											.removeClass('hidden');
										$('[data-button-success]').removeClass('hidden');
									} else if (response.status === 'error') {
										$('[data-alert-error]')
											.html(response.message)
											.removeClass('hidden');
									}
								}

								if (_formName === 'subscribe-footer') {
									if (response.RESULT !== 'E') {
										$(form)
											.find('[data-form-subscribe-success]')
											.removeClass('hidden')
											.addClass('show');
										(window['rrApiOnReady'] =
											window['rrApiOnReady'] || []).push(function() {
											rrApi.setEmail(response.EMAIL);
										});

										window.dataLayer = window.dataLayer || [];
										dataLayer.push({
											event: 'sendForm',
											formName: 'subscribe',
											formURL: 'wrangler.ru'
										});
										try {
											ym(79276948, 'reachGoal', 'subscribe');
										} catch (e) {}

										$(form)
											.find('button')
											.attr('disabled', 'disabled');
									} else {
										formValidate.showErrors({ email: response.MESSAGE });
									}
								}

								if (_formName === 'order-status') {
									$(form)
										.find('[data-alert-error]')
										.addClass('hidden');
									$(form)
										.find('[data-alert-success]')
										.addClass('hidden');

									if (response.status === 'ok') {
										$(form)
											.find('[data-alert-success]')
											.removeClass('hidden')
											.find('[data-order-status]')
											.text(response.message);
									} else if (response.status === 'error') {
										$(form)
											.find('[data-alert-error]')
											.text(response.message)
											.removeClass('hidden');
									}
								}

								if (_formName == 'reservation') {
									const res = new Popup($('#reservation-result'));
									res.open(response);
								}

								$('body').removeClass('body--loading'); // preloader
							},
							complete: function(xmlHttp) {
								// xmlHttp is a XMLHttpRquest object
								/*
                                if (_formName === 'regform' && !xmlHttp.responseJSON && xmlHttp.responseText.indexOf('<!DOCTYPE html>') !== -1 && xmlHttp.status === 200) {
                                    window.location.href = '/personal/';
                                }
                                */
							}
						});
					} else {
						form.submit();
					}

					return false;
				},
				rules: {
					ORDER_PROP_street: {
						complete: true,
						minlength: 3,
						found: true
					},
					ORDER_PROP_house: {
						complete: true,
						found: true
					}
				},
				messages: {
					ORDER_PROP_street: {
						complete: 'Пожалуйста, выберите улицу',
						found: 'Улица не найдена - проверьте адрес'
					},
					ORDER_PROP_house: {
						complete: 'Пожалуйста, выберите номер дома',
						found: 'Дом не найден - проверьте адрес'
					}
				}
			});
		});

		// Модификация classRules
		$.validator.addClassRules = function(className, rules) {
			if (className.constructor === String) {
				var obj = {};
				obj[className] = rules;
				className = obj;
			}
			$.each(className, function(n, r) {
				$('.' + n).each(function(i, e) {
					var self = $(e);
					self.rules('add', r);
				});
			});
		};

		$.extend($.validator.messages, {
			required: 'Пожалуйста, заполните поле',
			remote: 'Исправьте это поле чтобы продолжить',
			email: 'Введите правильный email адрес',
			url: 'Введите верный URL',
			date: 'Введите правильную дату',
			dateISO: 'Введите правильную дату (ISO)',
			number: 'Введите число',
			digits: 'Введите только цифры',
			creditcard: 'Введите правильный номер вашей кредитной карты',
			equalTo: 'Повторите ввод значения еще раз',
			accept: 'Пожалуйста, введите значение с правильным расширением',
			maxlength: $.validator.format('Не более {0} символов'),
			minlength: $.validator.format('Минимальное количество символов {0}'),
			rangelength: $.validator.format('Введите значения от {0} до {1}'),
			range: $.validator.format('Введите значение между {0} и {1}'),
			max: $.validator.format('Введите значение меньше {0}'),
			min: $.validator.format('введите значение больше {0}')
		});

		// Добавление правил на классы
		$.validator.addClassRules({
			'js-valid-name': {
				required: true,
				minlength: 2,
				regex: /^[а-яёА-ЯЁa-zA-Z]+$/,
				messages: {
					regex: 'Некорректные данные',
					minlength: 'Короткое имя'
				}
			},
			'js-valid-fio': {
				required: true,
				minlength: 3,
				messages: {
					minlength: 'Короткое имя'
				}
			},
			'js-valid-string': {
				required: true
			},
			'js-valid-city': {
				required: true,
				messages: {
					required: 'Пожалуйста, выберите город'
				}
			},
			'js-valid-email': {
				required: true,
				email: true,
				normalizer: function(value) {
					return $.trim(value);
				},
				messages: {
					email: 'Некорректные данные'
				}
			},
			'js-valid-phone': {
				required: true,
				phone: true
			},
			'js-valid-tel': {
				required: false,
				phone: true
			},
			'js-valid-number': {
				required: true,
				regex: /^\d+$/,
				messages: {
					regex: 'Пожалуйста, введите только цифры'
				}
			},
			'js-valid-card': {
				required: true,
				regex: /^\d+$/,
				minlength: 13,
				maxlength: 13,
				messages: {
					regex: 'Пожалуйста, введите только цифры',
					minlength: 'Пожалуйста, введите 13 символов',
					maxlength: 'Пожалуйста, введите 13 символов'
				}
			},
			'js-valid-pin': {
				required: true,
				regex: /^\d+$/,
				minlength: 4,
				maxlength: 4,
				password: false,
				messages: {
					regex: 'Пожалуйста, введите только цифры',
					minlength: 'Пожалуйста, введите 4 символа',
					maxlength: 'Пожалуйста, введите 4 символа'
				}
			},
			'js-valid-code': {
				required: true,
				regex: /^\d+$/,
				minlength: 5,
				maxlength: 5,
				password: false,
				messages: {
					regex: 'Пожалуйста, введите только цифры',
					minlength: 'Пожалуйста, введите 5 символов',
					maxlength: 'Пожалуйста, введите 5 символов'
				}
			},
			'js-valid-zip': {
				required: true,
				regex: /^\d+$/,
				minlength: 6,
				maxlength: 6,
				messages: {
					regex: 'Пожалуйста, введите только цифры',
					minlength: 'Пожалуйста, введите 6 символов',
					maxlength: 'Пожалуйста, введите 6 символов'
				}
			},
			'js-valid-adress': {
				required: true
			},
			'js-valid-check': {
				required: true,
				messages: {
					required: 'Пожалуйста, подтвердите ваше согласие'
				}
			},
			'js-valid-pass': {
				required: true,
				pass: true,
				notEqual: '.js-valid-old-pass',
				messages: {
					notEqual: 'Новый пароль должен отличаться от старого'
				}
			},
			'js-valid-pass-confirm': {
				required: true,
				equalTo: '.js-valid-pass',
				messages: {
					equalTo: 'Пароли не совпадают'
				}
			},
			'js-valid-date': {
				required: true
			},
			'js-valid-order-id': {
				required: true,
				regex: /^\d+$/,
				maxlength: 10,
				messages: {
					regex: 'Пожалуйста, введите только цифры'
				}
			}
		});

		var orderId = document.querySelectorAll('input.js-valid-order-id');
		Inputmask({
			mask: '9{0,10}',
			placeholder: ''
		}).mask(orderId);

		var zip = document.querySelectorAll('input.js-valid-zip');
		Inputmask({
			mask: '999999',
			placeholder: ''
		}).mask(zip);

		var tel = document.querySelectorAll('input[type=tel]');
		Inputmask({
			mask: '+7 (999) 999[-99][-99]',
			clearMaskOnLostFocus: true,
			placeholder: '',
			showMaskOnHover: false,
			showMaskOnFocus: true,
			greedy: false
		}).mask(tel);

		this.cityinput.off('keyup').on('keyup', function() {
			let city = $(this).val();
			let parent = $(this).closest('[data-city-parent]');
			let form = parent.find('form');
			let method = form.attr('method') || 'GET';
			let requestData = form.serialize();

			let url = $(this).data('ajax-url');
			if (!url) {
				url = form.attr('action');
			}

			form.find('[data-location-id]').val('');

			if (city.length > 2) {
				$.ajax({
					url: url,
					method: method,
					dataType: 'json',
					data: requestData
				})
					.done(function(response) {
						findCity(response, city, parent);
					})
					.fail(function() {
						if (process.env.NODE_ENV === 'development') {
							findCity(arReturn, city, parent);
						}
					});
			}
		});

		$('[data-form-subscribe-close]')
			.off('click')
			.on('click', function(e) {
				$(this)
					.closest('[data-form-subscribe-success]')
					.removeClass('show')
					.addClass('hidden');

				$(this)
					.closest('form')
					.find('button')
					.removeAttr('disabled');
			});

		$('[data-delivery-day-form]').on('change', function(e) {
			$.magnificPopup.close();
		});

		$('[data-delivery-time-form]').on('change', function(e) {
			$.magnificPopup.close();
		});

		function locationClickInit() {
			$('[data-location]')
				.off('click')
				.on('click', function(e) {
					let el = $(this);
					let form = el.closest('form');
					let location = el.attr('data-location');
					let locationId = el.attr('data-id');

					cityinput.val(location);
					form.find('[data-location-id]').val(locationId);

					if (form.attr('name') === 'cart-city') {
						$.ajax({
							url: '/local/ajax/select_city.php',
							method: 'POST',
							dataType: 'json',
							data: {
								id: locationId
							}
						})
							.done(function(response) {
								$('[data-property-store-id]').val('');
								$('[data-property-address]').val('');
								$('[data-property-location]').val(locationId);

								// На бою не успевает нормально отработать закрытие попапа
								// Поэтому обновление корзины вешается на событие закрытия, а не выполняется сразу
								window.needReload = 'Y';

								$.magnificPopup.close();
							})
							.fail(function() {
								$.magnificPopup.close();
							});
					}

					e.preventDefault();
				});
		}
		locationClickInit();

		function findCity(cityArray, city, parent) {
			let listCity = parent.find('[data-list-city]');
			listCity.html('');

			for (let i = 0; i < cityArray.length; i++) {
				let value = cityArray[i]['PATH'];
				let res = value.toLowerCase().includes(city.toLowerCase());

				if (res) {
					let locationItemTemplate = `<a href="#" class="popup__city-item link color--old-brick" data-id="${cityArray[i]['ID']}" data-location="${cityArray[i]['NAME_RU']}">${cityArray[i]['NAME_RU']}</a>`;
					listCity.append(locationItemTemplate);
				}
			}

			locationClickInit();
		}

		function onCompleteInputDaData(event) {
			$(event.target).removeClass('complete');
			$(event.target).off('input', onCompleteInputDaData);
		}

		function formatStreet(data) {
			const settlement = data.settlement_with_type
				? `${data.settlement_with_type}, `
				: '';
			const area = data.area_with_type ? `${data.area_with_type}, ` : '';
			return `${settlement}${area}${data.street_type_full} ${data.street}`.trim();
		}

		function initAutocompleteStreet(element) {
			let streetNames;
			element.autocomplete({
				source: function(request, response) {
					let _this = $(this.element);
					let city = $('[data-location-city]')
						.first()
						.text()
						.trim();
					if (_this.is('[data-adress-street]')) {
						$('.ui-autocomplete').addClass('narrow');
						city = _this
							.closest('[data-city-parent]')
							.find('[data-find-city]')
							.val();
					}
					_this.removeClass('found');

					const query = request.term;

					_this[query ? 'addClass' : 'removeClass']('complete');

					if (query.length < 3) {
						return;
					}

					var options = {
						method: 'POST',
						mode: 'cors',
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
							Authorization: 'Token ' + DaDataToken
						},
						body: JSON.stringify({ query: `${city} ${query}` })
					};

					fetch(DaDataUrl, options)
						.then(response => response.text())
						.then(result => {
							streetNames = JSON.parse(result)
								.suggestions.filter(el => el.data.street)
								.map(el => ({
									sreetId: el.data.street_fias_id || null,
									street: formatStreet(el.data) || ''
								}))
								.filter(
									(value, index, self) =>
										self.findIndex(el => el.sreetId === value.sreetId) === index
								);
							response(streetNames.map(el => el.street));
						})
						.catch(error => console.log('error', error));
				},
				select: function(event) {
					$(event.target).addClass('found');
					$(event.target).addClass('complete');
					$(event.target)
						.trigger('keyup')
						.trigger('change');
					$(event.target).on('input', onCompleteInputDaData);
				},
				close: function(event) {
					const currentValue = $(event.target)
						.val()
						.toLowerCase()
						.trim();
					const matchedStreet =
						streetNames.find(el => {
							return el.street.toLowerCase().includes(currentValue);
						}).street ||
						streetNames.find(el => {
							return currentValue
								.split(' ')
								.some(item => el.street.toLowerCase().includes(item));
						}).street;

					if (matchedStreet && currentValue) {
						$(event.target).addClass('found');
						$(event.target).val(matchedStreet);
						$(event.target)
							.trigger('keyup')
							.trigger('change');
						$(event.target).on('input', onCompleteInputDaData);
					}
				}
			});
		}

		const formatHouse = data => {
			if (!data.house_fias_id && !data.stead_fias_id) {
				return '';
			}
			if (data.stead_fias_id) {
				return `${data.stead} ${data.stead_type}`.trim();
			}
			const house = data.house ? `${data.house} ` : '';
			const blockType = data.block_type ? `${data.block_type} ` : '';
			const block = data.block ? `${data.block} ` : '';

			return `${house}${blockType}${block}`.trim();
		};

		window.initAutocompleteHouse = function(element) {
			let houseNumbers;
			element.autocomplete({
				source: function(request, response) {
					let _this = $(this.element);

					let city = $('[data-location-city]')
						.first()
						.text()
						.trim();
					let street = $('[data-street]').val();

					if (_this.is('[data-adress-house]')) {
						city = _this
							.closest('[data-city-parent]')
							.find('[data-find-city]')
							.val();
						street = _this
							.closest('[data-city-parent]')
							.find('[data-adress-street]')
							.val();
					}

					_this.removeClass('found');

					const query = request.term.trim();
					_this[query ? 'addClass' : 'removeClass']('complete');

					var options = {
						method: 'POST',
						mode: 'cors',
						count: 7,
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
							Authorization: 'Token ' + DaDataToken
						},
						body: JSON.stringify({ query: `${city} ${street} ${query}` })
					};

					fetch(DaDataUrl, options)
						.then(response => response.text())
						.then(result => {
							houseNumbers = JSON.parse(result)
								.suggestions.map(el => formatHouse(el.data))
								.filter((value, index, self) => self.indexOf(value) === index);
							response(houseNumbers);
						})
						.catch(error => console.log('error', error));
				},
				select: function(event) {
					$(event.target).addClass('found');
					$(event.target)
						.trigger('keyup')
						.trigger('change');
					$(event.target).on('input', onCompleteInputDaData);
				},
				close: function(event) {
					const currentValue = $(event.target).val();
					if (houseNumbers.includes(currentValue)) {
						$(event.target).addClass('found');
						$(event.target)
							.trigger('keyup')
							.trigger('change');
						$(event.target).on('input', onCompleteInputDaData);
					}
				}
			});
		};

		initAutocompleteStreet($('[data-street], [data-adress-street]'));
		initAutocompleteHouse($('[data-house], [data-adress-house]'));

		if (process.env.NODE_ENV === 'development') {
			arReturn = [
				{
					CITY_ID: '84',
					CODE: '0000073738',
					COUNTRY_ID: '1',
					DEPTH_LEVEL: '2',
					ID: '84',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '168',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва',
					PARENT_ID: '1',
					PATH: 'Москва',
					REGION_ID: null,
					RIGHT_MARGIN: '1181',
					SORT: '100',
					TYPE_CODE: 'CITY',
					TYPE_ID: '5',
					ZIP: '101000'
				},
				{
					CITY_ID: null,
					CODE: '0000244853',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '4',
					ID: '59444',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '321812',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва деревня',
					PARENT_ID: '832',
					PATH: 'Москва деревня, Пеновский район, Тверская область',
					REGION_ID: null,
					RIGHT_MARGIN: '321813',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '172796'
				},
				{
					CITY_ID: null,
					CODE: '0000372698',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '4',
					ID: '113984',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '210530',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва деревня',
					PARENT_ID: '1512',
					PATH: 'Москва деревня, Порховский район, Псковская область',
					REGION_ID: null,
					RIGHT_MARGIN: '210531',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '182620'
				},
				{
					CITY_ID: null,
					CODE: '0000587518',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '4',
					ID: '142881',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '151678',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва деревня',
					PARENT_ID: '2432',
					PATH: 'Москва деревня, Верхошижемский район, Кировская область',
					REGION_ID: null,
					RIGHT_MARGIN: '151679',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '613310'
				},
				{
					CITY_ID: null,
					CODE: '0000062456',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '5',
					ID: '15007',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '411585',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва снт',
					PARENT_ID: '15002',
					PATH:
						'Москва снт, Ильинки деревня, Сергиево-Посадский район, Московская область',
					REGION_ID: null,
					RIGHT_MARGIN: '411586',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '141325'
				},
				{
					CITY_ID: null,
					CODE: '0000064085',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '5',
					ID: '15873',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '410575',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Москва снт',
					PARENT_ID: '15871',
					PATH:
						'Москва снт, Озерецкое село, Сергиево-Посадский район, Московская область',
					REGION_ID: null,
					RIGHT_MARGIN: '410576',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '141354'
				},
				{
					CITY_ID: null,
					CODE: '0000064086',
					COUNTRY_ID: null,
					DEPTH_LEVEL: '5',
					ID: '15874',
					LATITUDE: '0.000000',
					LEFT_MARGIN: '410576',
					LOC_DEFAULT: 'N',
					LONGITUDE: '0.000000',
					NAME_RU: 'Воронеж',
					PARENT_ID: '15871',
					PATH: 'Воронеж, Воронежская область',
					REGION_ID: null,
					RIGHT_MARGIN: '410577',
					SORT: '100',
					TYPE_CODE: 'VILLAGE',
					TYPE_ID: '6',
					ZIP: '141355'
				}
			];
		}
	}
}

window.InputClass = new Input();

export { Input };
